import { useState } from 'react';
import { GripVertical, ChevronUp, ChevronDown, X } from 'lucide-react';

const move = (list, from, to) => {
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
};

export const BookletOrderList = ({ ids, verses, onChange }) => {
  const [dragIndex, setDragIndex] = useState(null);
  const [overIndex, setOverIndex] = useState(null);
  const byId = Object.fromEntries(verses.map((v) => [v.id, v]));

  if (ids.length === 0) return null;

  const drop = (to) => {
    if (dragIndex !== null && dragIndex !== to) onChange(move(ids, dragIndex, to));
    setDragIndex(null);
    setOverIndex(null);
  };

  return (
    <div className="space-y-2 min-w-0 w-full" data-testid="booklet-order-list">
      <p className="text-xs font-cinzel uppercase tracking-wider text-[#D4AF37]">Your booklet order · drag to arrange</p>
      {ids.map((id, i) => (
        <div
          key={id}
          draggable
          onDragStart={() => setDragIndex(i)}
          onDragOver={(e) => { e.preventDefault(); setOverIndex(i); }}
          onDragLeave={() => setOverIndex(null)}
          onDrop={() => drop(i)}
          onDragEnd={() => { setDragIndex(null); setOverIndex(null); }}
          className={`flex items-center gap-2 p-2 rounded-lg border bg-[#160A0D] transition-colors cursor-grab active:cursor-grabbing ${
            overIndex === i ? 'border-[#D4AF37]' : 'border-[#D4AF37]/15'
          } ${dragIndex === i ? 'opacity-40' : ''}`}
          data-testid={`booklet-order-item-${i}`}
        >
          <GripVertical className="w-4 h-4 text-[#C2B49A] shrink-0" />
          <span className="text-xs font-cinzel text-[#D4AF37] w-5 shrink-0">{i + 1}.</span>
          <p className="text-sm text-[#F4EFE6] font-serif italic truncate flex-1 min-w-0" title={byId[id]?.preview_text}>
            {byId[id]?.preview_text}
          </p>
          <button type="button" disabled={i === 0} onClick={() => onChange(move(ids, i, i - 1))}
            className="p-1 text-[#C2B49A] hover:text-[#D4AF37] disabled:opacity-30" aria-label="Move up" data-testid={`booklet-order-up-${i}`}>
            <ChevronUp className="w-4 h-4" />
          </button>
          <button type="button" disabled={i === ids.length - 1} onClick={() => onChange(move(ids, i, i + 1))}
            className="p-1 text-[#C2B49A] hover:text-[#D4AF37] disabled:opacity-30" aria-label="Move down" data-testid={`booklet-order-down-${i}`}>
            <ChevronDown className="w-4 h-4" />
          </button>
          <button type="button" onClick={() => onChange(ids.filter((x) => x !== id))}
            className="p-1 text-[#C2B49A] hover:text-[#FF6B6B]" aria-label="Remove" data-testid={`booklet-order-remove-${i}`}>
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};
